// reg-hub-common-config.ts
import { InjectionToken } from '@angular/core';

export interface RegHubCommonConfig {
    rootUrl: string;
    batchRootURL: string;
    consortiumRootURL: string;
}

export const REG_HUB_COMMON_CONFIG = new InjectionToken<RegHubCommonConfig>('RegHubCommonConfig');